import React from 'react';

const DigitalGoldSection = () => {
    const features = [
        "Buy or sell anytime, anywhere",
        "No storage or handling required",
        "Start saving from as little as AED 10",
        "Transparent, real-time pricing",
        "Easily redeemable for physical gold"
    ];

    return (
        <section className="p-2 sm:p-4 lg:p-6">
            <div className="max-w-6xl mx-auto">
                <div className="flex flex-col md:flex-row-reverse md:gap-12 lg:gap-16 py-6 sm:py-8 lg:py-12 px-4 sm:px-6 lg:px-8">
                    {/* Text Section */}
                    <div className="w-full md:w-1/2 text-center md:text-left space-y-4 sm:space-y-6">
                        <div>
                            <div className="flex items-center mb-4">

                                <h2 className="text-[32px] leading-[1.1] md:text-[44px] font-semibold text-primary items-center mx-auto md:mx-0">Best App for Digital Gold Investment in UAE
                                </h2>
                            </div>
                            <p className=" md:text-lg mb-8">
                                Digital gold is real 24K gold—bought, stored, and managed online. It gives you the security of physical gold with the flexibility of instant, digital access.

                            </p>
                            <div className="space-y-2 md:space-y-4 ">
                                {features.map((feature, index) => (
                                    <div key={index} className="flex items-center">
                                        <div className="mr-4 text-gold-500">
                                            <svg className='text-primary' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M22 4L12 14.01L9 11.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                        <div>
                                            <h3 className="text-lg text-dark-800 mb-1 text-start md:text-center">{feature}</h3>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    {/* Image Section */}
                    <div className="w-full md:w-1/2 flex justify-center md:justify-start items-center">
                        <img
                            src="/exp-ins.svg"
                            alt="Gold Protection Icon"
                            className="w-[80%]  md:w-[320px] lg:w-[420px] lg:ml-12 h-auto object-contain "
                            loading="lazy"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DigitalGoldSection;